export const translationOverrides = {
  en: {
    ABOUT_COMPONENT: {
      title: "About aplication",
      ABOUT_TEXT: {
        a: "This web map application shows selected agro-climatic factors for the years 2009 to 2019 calculated as moving averages from the previous 5 years. It is always possible to display an estimate of their uncertainty for individual factors.",
        b: "Agro-climatic factors show frost-free period, water balance, total precipitation, amount of solar radiation, last day suitable for nitrogen fertilizers and a group of factors related to wheat growth (as a reference crop), namely temperatures suitable for its growth, and the amount of heat stress suppressing its growth.",
        ca: "The displayed agro-climatic factors are derived from the global data of the European program Copernicus (",
        cb: ") and are calculated by the methodology",
        cc: "Calculation of Agro-Climatic Factors from Global Climatic Data",
      },
    },
    LAYERS: {
      frdays: "Number of days without frost",
      wbalanc: "Change in water reserves in the area in millimeters",
      "Množství dešťové vody dopadlé na povrch v mm":
        "The amount of total precipitation on the surface in millimeters",
      sradi:
        "Annual summary of incident solar radiation on the surface in MJ*m^(-2)",
      fertdate:
        "Order of the last day of the year when the soil temperature reaches more than 10 °C",
      hsu: "Cumulative sum of values ​​of differences of maximum daily temperatures and temperature of 31 °C in a given year",
      hsu3: "Roční suma tepelného stresu pro kukuřici (nad 30 °C)",
      logp: "Number of days in year with suitable temperatire for wheat",
      logp3: "Number of days in year with suitable temperatire for corn",
      lgp: "Number of days in year with optimal temperatire for wheat",
      lgp3: "Number of days in year with optimal temperatire for corn",
      gdu: "Yearly growing degree units above 3.5 °C for wheat",
      gdu2: "Yearly growing degree units above 0 °C",
      gdu3: "Yearly growing degree units above 10 °C for corn",
      runoff: "Yearly runoff",
      evapo: "Yearly evapotranspiration",
      ffdate: "First frost date in season",
      lfdate: "Last frost date in season",
      fperiod: "Frost period",
      tavg: "Yearly average temperature",
      preci: "Yearly precipitation",

      abst_frdays:
        "Number of days between the last spring frost and the first autumn frost. The period in which the temperatures reach the values ​​required for the growth of crops, respectively period without devastating effects of frosts.",
      abst_wbalanc:
        "The difference between the total precipitation and all evaporation and runoff from a given area. Suitable for detecting changes in water supplies in a given area, especially the detection of water deficits in a given area that may affect crop growth.",
      abst_preci:
        "Amount of rainwater falling on the surface. Suitable as information on the availability of water for crops in the area.",
      abst_sradi:
        "Annual summary of incident sunlight on the surface. Suitable as information on the availability of sunlight for the crop.",
      abst_fertdate:
        "Soil temperature in autumn and winter is another important agro-climatic factor. The farmer can use it to plan the application of nitrogen fertilizers. If the soil temperature is higher than 10 °C, nitrogen may be lost from the soil. This agro-climatic factor therefore shows the last autumn days in which the soil temperature reaches above 10 ° C (expressed in the form of the day number of the year).",
      abst_vhodne_teploty:
        "The sum of the days when the average daily temperature is suitable for wheat growth is in the range from 3.5 °C to 31 °C",
      abst_optim_teploty:
        "The sum of the days when the average daily temperature is optimal for wheat growth is in the range from 12 °C to 25 °C.",
      abst_hsu:
        "In addition to frost, too high temperatures are destructive to crops. HSU (heat stress units) is a unit that detects these temperatures. If the daily maximum temperature is higher than the set absolute maximum for a given crop (for wheat 31 °C), the difference between these temperatures is the daily HSU. The annual HSU is then the sum of all daily HSUs.",
      cfd: "Climatic factors data",
      abst_logp: "",
      abst_lgp: "",
      abst_gdu: "",
      abst_runoff: "",
      abst_evapo: "",
      abst_ffdate: "",
      abst_lfdate: "",
      abst_fperiod: "",
      abst_tavg: "",
    },
    LAYERMANAGER: {
      "Bezmrazové období": "Frost-free period",
      "Bilance vody": "Water balance",
      "Úhrn srážek": "Total precipitation",
      "Množství slunečního záření": "Total solar radiation",
      "Poslední den teploty půdy nad 10°C, který je vhodný pro aplikaci dusíkatých hnojiv":
        "Last date with soil temperature above 10 °C suitable for nitrogen application",
      "Vhodné teploty pro růst pšenice":
        "Growing temperatures suitable for wheat",
      "Optimální teploty pro růst pšenice":
        "Optimal growing temperatures suitable for wheat",
      "Množství tepelného stresu pro pšenici": "Heat stress units for wheat",
      time: {
        time: "Time",
      },
    },
    CHARTS: {
      dataFrequency: {
        week: "Week",
        year: "Year",
      },
      title: {
        fperiod: "Frost-free period",
        wbalanc: "Water balance",
        preci: "Total precipitation",
        sradi: "Total solar radiation",
        fertdate: "Last suitable date for fall nitrogen fertilization",
        frdays: "Water balance to be added ",
        gdu: "Growing degree units (GDU)",
        hsu: "Heat stress units (HSU)",
        cumulativeGDU: "Accumulated growing degree units (GDU)",
        tavg: "Average temperature",
        clima: "Clima diagram",
        evapo: "Evapotranspiration",
        lgp: "Growing temperatures",
        lfdate: "Last spring freeze",
        ffdate: "First fall freeze",
        diy: "Day in year",
        diw: "Days in week",
        nod: "Number of days in year",
        // "Poslední den teploty půdy nad 10°C, který je vhodný pro aplikaci dusíkatých hnojiv":'Last date with soil temperature above 10 °C suitable for nitrogen application',
      },
      uncertainity: "Uncertainities",
      yearGduLegend: {
        unsufficient: "Unsufficient",
        sufficient: "Sufficient",
        optimal: "Optimal",
      },
      weekgduLegend: {
        //C3
        offseason: "Off season",
        emergence: "Emergence",
        twoleaves: "Leaf stages - two leaves unfolded",
        fourleaves: "Leaf stages - four leaves unfolded",
        sixleaves: "Leaf stages - six leaves unfolded",
        floweringBegins: "Flowering begins",
        floweringHalf: "Flowering 50% complete",
        seedFill: "Seed fill",
        maturityFirstStage: "Maturity (seed begins to mature)",
        maturity: "Maturity complete",
        //C4
        sixLeafCollars: "6 leaf collars",
        twlveLeafCollar: "12 leaf collars",
        tassel: "Tassel",
        silk: "Silk",
        blister: "Blister",
        milk: "Milk",
        dough: "Dough",
        dent: "Dent",
        physMaturity: "Physiological maturity",
        //Whear
        leafDefelopement: "Leaf development",
        tillering: "Tillering",
        stemElongation: "Stem elongation",
        anthesis: "Anthesis",
        doughStage: "Dough stage",
        bootSwelling: "Boot Swelling Begins",
        swathing: "Swathing",
      },
      weekpreciLegend: {
        offseason: "Off season",
        necessary: "Necessary",
        reserve: "Reserve",
        excess: "Excess",
      },
      growingPhase: "Growing phase",
      frostPeriod: "Frost period",
    },
    STRATEGY: {
      panelTitle: "Agroclimatic analysis",
      panelDescription: "Agroclimatic factor charts",
      overviewTypes: {
        place: "Place overview",
        crop: "Crop overview",
      },
      seasonStart: "Season start",
      noPlaceSelected: "No place selected",
      crop: "Crop",
      moreCharacteristics: "Want to see more place characteristics?",
      generateCharts: "Generate charts!",
      generatingCharts: "Generating charts!",
      crops: {
        sunflower: "Sunflower",
        wheat: "Wheat",
        corn: "Corn",
        barley: "Barley",
        oat: "Oat",
        canolaNapus: "Canola (Napus)",
        canolaRapa: "Canola (Rapa",
        pea: "Pea",
        lentil: "Lentil",
      },
      errorWhileRequestingChartData: "Error while requesting chart data",
      coordinatesOutOfBounds:
        "Selected coordinates are not within bounds. No data available",
      week: "Week",
      year: "Year",
      month: "Month",
      selectedYear: "Selected year",
      changeSeasonStart: "Change season start date",
      zoomToChart: "While active double-click on chart will create close up",
    },
    MAPOVERLAY: {
      opacity: "Transparency",
      LOCATIONS: {
        czechia: "Czechia",
        latvia: "Latvia",
        slovakia: "Slovakia",
        sanJuan: "San Juan (ARG)",
      },
    },
  },
  cs: {
    ABOUT_COMPONENT: {
      title: "O aplikaci",
      ABOUT_TEXT: {
        a: "Tato webová mapová aplikace zobrazuje vybrané agroklimatické faktory pro roky 2009 až 2019 vypočtené jako klouzavé průměry z předchozích 5-ti let. K jednotlivým faktorům je možné vždy zobrazit i odhad jejich neurčitosti.",
        b: "Agroklimatické faktory zobrazují: období bez mrazu, bilanci vody, úhrn srážek, množství dopadlého slunečního záření, poslední den vhodný pro aplikaci dusíkatých hnojiv a skupinu faktorů vztažených k růstu pšenice (jakožto referenční plodiny) a to teploty vhodné pro její růst a naopak množství tepelného stresu potlačující její růst.",
        ca: "Zobrazené agroklimatické faktory jsou odvozené od globálních dat evropského programu Copernicus (",
        cb: ") a jsou vypočítávány metodikou",
        cc: "Calculation of Agro-Climatic Factors from Global Climatic Data",
      },
    },
    LAYERS: {
      frdays: "Počet dnů bez mrazu",
      wbalanc: "Změna v zásobách vody na daném území v mm",
      sradi: "Roční souhrn dopadlého slunečního záření na povrch v MJ*m^-2",
      fertdate:
        "Pořadí posledního dne v roce, kdy dosahuje teplota půdy více jak 10°C",
      logp: "Počet dní v roce s optimálními teplotami pro pšenici",
      logp3: "Počet dní v roce s optimálními teplotami pro kukuřici",
      lgp: "Počet dní v roce s vhodnými teplotami pro pšenici",
      lgp3: "Počet dní v roce s vhodnými teplotami pro kukuřici",
      gdu: "Roční suma efektivních teplot nad 3.5 °C pro pšenici",
      gdu2: "Roční suma teplot nad 0°C ",
      gdu3: "Roční suma efektivních teplot nad 10°C pro kukuřici",
      runoff: "Roční odtok vody",
      evapo: "Roční evapotranspirace",
      ffdate: "První datum mrazu na podzim",
      lfdate: "Poslední datum mrazu na jaře",
      fperiod: "Bezmrazové období",
      tavg: "Průměrná roční teplota",
      preci: "Roční úhrn srážek",
      hsu: "Roční suma tepelného stresu pro pšenici (nad 31°C)",
      hsu3: "Roční suma tepelného stresu pro kukuřici (nad 30 °C)",
      abst_frdays:
        "Počet dní mezi posledním jarním mrazem a prvním podzimním mrazem. Období, ve kterém teploty dosahují hodnot žádoucích pro růst plodin, resp. období bez devastačních účinků mrazů.",
      abst_wbalanc:
        "Rozdíl srážkového úhrnu s veškerým výparem a odtokem z daného území. Vhodné pro detekci změn v zásobách vody na daném území, především odhalení deficitů vody na daném území, které můžou mít vliv na růst plodin.",
      abst_preci:
        "Množství dešťové vody dopadlé na povrch. Vhodné jako informace o dostupnosti vody pro plodiny na daném území.",
      abst_sradi:
        "Roční souhrn dopadlého slunečního záření na povrch. Vhodné jako informace o dostupnosti slunečního záření pro plodinu.",
      abst_fertdate:
        "Teplota půdy na podzim a v zimě je dalším důležitým agroklimatickým faktorem. Zemědělec ho může využít při plánování aplikace dusíkatých hnojiv. Pokud je teplota půdy vyšší než 10°C, může docházet ke ztrátě dusíku z půdy. Tento agroklimatický faktor tedy ukazuje poslední podzimní dny, ve kterých dosahuje teplota půdy nad 10°C (vyjádřeno ve formě čísla pořadí dne v roce",
      abst_vhodne_teploty:
        "Součet dnů, kdy průměrná denní teplota je vhodná pro růst pšenice, je v intervalu od 3.5 do 31°C.",
      abst_optim_teploty:
        "Součet dnů, kdy průměrná denní teplota je optimální pro růst pšenice, je v intervalu od 12 do 25°C.",
      abst_hsu:
        "Kromě mrazu, jsou pro plodiny ničivé i příliš vysoké teploty. HSU (heat stress units) je jednotkou, která tyto teploty odhaluje. Pokud je denní maximální teplota vyšší než stanovené absolutní maximum pro danou plodinu (pro pšenici 31°C), rozdíl těchto teplot je denní HSU. Roční HSU je poté součet všech denních HSU.",
      cfd: "Rozsah dat klimatických faktorú",
      abst_logp: "počet dní v roce s optimálními teplotami pro pšenici (dny)",
      abst_lgp: "počet dní v roce s vhodnými teplotami pro pšenici (dny)",
      abst_gdu: "roční suma efektivních teplot nad 3.5 °C pro pšenici (°C)",
      abst_runoff: "",
      abst_evapo: "",
      abst_ffdate: "",
      abst_lfdate: "",
      abst_fperiod: "",
      abst_tavg: "",
    },
    LAYERMANAGER: {
      "Bezmrazové období": "Bezmrazové období",
      "Bilance vody": "Bilance vody",
      "Úhrn srážek": "Úhrn srážek",
      "Množství slunečního záření": "Množství slunečního záření",
      "Poslední den teploty půdy nad 10°C, který je vhodný pro aplikaci dusíkatých hnojiv":
        "Poslední den teploty půdy nad 10°C, který je vhodný pro aplikaci dusíkatých hnojiv",
      "Vhodné teploty pro růst pšenice": "Vhodné teploty pro růst pšenice",
      "Optimální teploty pro růst pšenice":
        "Optimální teploty pro růst pšenice",
      "Množství tepelného stresu pro pšenici":
        "Optimální teploty pro růst pšenice",
      time: {
        time: "Čas",
      },
    },
    CHARTS: {
      dataFrequency: {
        week: "Týdně",
        year: "Ročně",
      },
      title: {
        fperiod: "Bezmrazové období",
        wbalanc: "Bilance vody",
        preci: "Úhrn srážek",
        sradi: "Množství slunečního záření",
        fertdate: "Poslední vhodný datum pro aplikaci dusíkatých hnojiv",
        frdays: "Water balance to be added",
        gdu: "Efektivní teploty",
        hsu: "Tepelný stres",
        cumulativeGDU: "Kumulované efektivní teploty",
        tavg: "Průměrná teplota",
        clima: "Klimatický diagram",
        evapo: "Evapotranspirace",
        lgp: "Dostatečná teplota na rust",
        lfdate: "Poslední jarní mráz",
        ffdate: "První jesenný mráz",
        diy: "Den v roce",
        diw: "Dnů v týdnu",
        nod: "Počet dní v roce",
      },
      uncertainity: "Nejistoty",
      yearGduLegend: {
        unsufficient: "Nedostačující množství",
        sufficient: "Dostačující množství",
        optimal: "Optimální množství",
      },
      weekgduLegend: {
        //sunflower
        offseason: "Mimo sezónu",
        emergence: "Vzcházení osiva",
        twoleaves: "2. list vyvinutý",
        fourleaves: "4. list vyvinutý",
        sixleaves: "6. list vyvinutý",
        floweringBegins: "Počátek kvetení",
        floweringHalf: "50% kvetení dokončeno",
        seedFill: "Vývoj plodů",
        maturityFirstStage: "Zrno dozrálo",
        maturity: "Zralost",
        //C4
        sixLeafCollars: "Vytvořený 6. list",
        twlveLeafCollar: "Vytvořený 12. list",
        tassel: "Tassel",
        silk: "Silk",
        blister: "Blister",
        milk: "Mléčná zralost",
        dough: "Plody začínají měknout",
        dent: "Dent",
        physMaturity: "Fyziologická zralost",
        //Whear
        leafDefelopement: "Tvorba listů",
        tillering: "Odnož",
        stemElongation: "Prodlužování hlavního stonku",
        anthesis: "Kvetení",
        bootSwelling: "Boot Swelling Begins",
        swathing: "Řádkování",
      },
      weekpreciLegend: {
        offseason: "Mimo sezónu",
        necessary: "Potřebné",
        reserve: "Rezerva",
        excess: "Přebytek",
      },
      growingPhase: "Růstová fáze",
      frostPeriod: "Mrazové období",
    },
    STRATEGY: {
      panelTitle: "Agroklimatická analýza",
      panelDescription: "Grafy agroklimatických faktorů",
      overviewTypes: {
        place: "Přehled místa",
        crop: "Přehled plodin",
      },
      seasonStart: "Začátek sezóny",
      noPlaceSelected: "Lokalita nevybrána",
      crop: "Plodina",
      moreCharacteristics: "Chcete videt více charakteristik?",
      generateCharts: "Vytvořit grafy!",
      generatingCharts: "Vytvářím grafy!",
      crops: {
        sunflower: "Slunečnice",
        wheat: "Pšenice",
        corn: "Kukuřice",
        barley: "Ječmen",
        oat: "Oves",
        canolaNapus: "Brukev řepka",
        canolaRapa: "Brukev řepák",
        pea: "Hrách",
        lentil: "Čočka",
      },
      errorWhileRequestingChartData: "Chyba pri žádání dat grafu ze serveru",
      coordinatesOutOfBounds: "Pro zvolené místo neexistujou žádná data!",
      week: "Týden",
      year: "Rok",
      month: "Měsíc",
      selectedYear: "Vybraný rok",
      changeSeasonStart: "Změnit datum začátku sezóny",
      zoomToChart: "Po aktivaci spůsobí dvojklik na graf jeho zvětšení",
    },
    MAPOVERLAY: {
      opacity: "Průhlednost",
      LOCATIONS: {
        czechia: "Česko",
        latvia: "Lotyšsko",
        slovakia: "Slovensko",
        sanJuan: "San Juan (ARG)",
      },
    },
  },
};
